import React from 'react';
import { func, bool, string } from 'prop-types';

import { withGroupContext } from 'context/groupContext';
import convertGroupIdToLabel from 'helpers/convertGroupIdToLabel';

import Tooltip from '@material-ui/core/Tooltip';

import {
  Label,
  ExportIcon,
  EditIcon,
  ExportButton,
  EditButton,
  StyledSwitch,
  Wrapper,
} from './ButtonGroup.style';

export function ButtonGroup({
  editModeEnabled,
  onExportClick,
  onEditModeClick,
  onReferenceToggle,
  showSmoothData,
  onSmoothDataToggle,
  showReference,
  referenceId,
  userHasFullAccess,
}) {
  return (
    <Wrapper>
      <span>
        <Label>{`"${convertGroupIdToLabel(referenceId)}" ${
          showReference ? 'enabled' : 'disabled'
        }`}</Label>
        <Tooltip
          title={`${showReference ? 'disable' : 'enable'}`}
          placement="top"
        >
          <StyledSwitch onChange={onReferenceToggle} checked={showReference} disabled={true} />
        </Tooltip>
      </span>
      <span>
        <Label>Smooth data</Label>
        <StyledSwitch onChange={onSmoothDataToggle} checked={showSmoothData} disabled={true} />
      </span>
      <Tooltip title="Export chart" placement="top">
        <ExportButton variant="contained" disabled={true}>
          <ExportIcon />
        </ExportButton>
      </Tooltip>
      {userHasFullAccess && (
        <Tooltip title="Enable edit mode" placement="top">
          <EditButton
            variant="contained"
            onClick={onEditModeClick}
            editModeEnabled={editModeEnabled}
          >
            <EditIcon />
          </EditButton>
        </Tooltip>
      )}
    </Wrapper>
  );
}

ButtonGroup.propTypes = {
  referenceId: string.isRequired,
  showReference: bool,
  onReferenceToggle: func.isRequired,
  showSmoothData: bool,
  onSmoothDataToggle: func.isRequired,
  editModeEnabled: bool,
  onExportClick: func.isRequired,
  onEditModeClick: func.isRequired,
  userHasFullAccess: bool.isRequired,
};

export default withGroupContext(ButtonGroup);



// WEBPACK FOOTER //
// ./src/components/ButtonGroup/ButtonGroup.js